export default __webpack_public_path__ + "static/media/Badge_yellow.74a1ed44.svg";